import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIUsersAccessByAcl, UsersAccessByAclReportRequest } from './UsersAccessByAcl.api';

export const fetchUsersAccessByAcl = createAsyncThunk(
    'reports/usersAccessByAcl',
    async ({ tenantId, request }: { tenantId: string, request: UsersAccessByAclReportRequest }) => {
        const response = await APIUsersAccessByAcl({ tenantId, request });
        if (!response.success || response.error) {
            throw new Error(response.error ?? 'Failed to fetch new users access report data (ACL)');
        }
        return response.data;
    }
);
